// import React from 'react';
import styled from 'styled-components';

export default styled.ul`
  list-style: none;
  margin: 0;
  padding: .5rem 0;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 2;
`;
